import { render } from "./NewIcon.vue?vue&type=template&id=5e488938"
import script from "./NewIcon.vue?vue&type=script&lang=js"
export * from "./NewIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__